import React from 'react';
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import { invitationReady } from '~/helpers/invitation';
import MyDocuments from "./MyDocuments";
import TextTranslate from '../../Components/TextTranslate/TextTranslate';
import { ChevronRight, EditIcon } from '../../Components/Icons/Icons';

const StatusConfirmed = ({guests, invitation, isMobile, children}) => {

    if (invitation.rsvp_status !== 'confirmed') {
        return <></>;
    }

    const formFinished = invitationReady(guests);

    return (
        <>
            {children}
            <hr className="d-none d-lg-block" />
            <div className="settings__item">
                <div>
                    <label><TextTranslate name="word-rsvp-status" fallback="RSVP Status"/></label>
                    <p className="font-weight-500"><TextTranslate name="word-attendance-confirmed" fallback="Attendance confirmed" /></p>
                </div>
                <div className="text-right">
                    {isMobile ?
                        <Link to="/decline" className="btn btn-icon-only p-0">
                            <EditIcon />
                        </Link>
                        :
                        <Link to="/decline" className="link text-primary"><TextTranslate name="word-change" fallback="Change"/> <TextTranslate name="word-rsvp-status" fallback="RSVP Status"/></Link>
                    }
                </div>
            </div>

            <hr className="d-none d-lg-block" />

            <div className="settings__item">
                <div>
                    <label><TextTranslate name="word-registration-status" fallback="Registration Status"/></label>
                    <p className="font-weight-500"><TextTranslate name={`reg-status-${invitation.registration_status}`}/></p>
                </div>
                <div className="text-right">
                    {invitation.registration_status === 'pending' && (
                        <>
                        {isMobile ?
                            <Link to="/registration" className="btn btn-icon-only p-0">
                                <ChevronRight />
                            </Link>
                            :
                            <Link to="/registration" className="link text-primary">
                                <span><TextTranslate name="word-start-registration" fallback="Start Registration"/></span>
                            </Link>
                        }
                        </>
                    )}

                    {invitation.registration_status === 'in_progress' && formFinished && (
                        <>
                        {isMobile ?
                            <Link to="/preview" className="btn btn-icon-only p-0">
                                <ChevronRight />
                            </Link>
                            :
                            <Link to="/preview" className="link text-primary">
                                <TextTranslate name="word-review-submit" fallback="Review & Submit"/>
                            </Link>
                        }
                        </>
                    )}

                    {invitation.registration_status === 'in_progress' && !formFinished && (
                        <>
                        {isMobile ?
                            <Link to="/registration" className="btn btn-icon-only p-0">
                                <ChevronRight />
                            </Link>
                            :
                            <Link to="/registration" className="link text-primary">
                                <TextTranslate name="word-continue-registration" fallback="Continue Registration"/>
                            </Link>
                        }
                        </>
                    )}

                    {invitation.registration_status === 'submitted' && (
                        <>
                        {isMobile ?
                            <Link to="/preview" className="btn btn-icon-only p-0">
                                <ChevronRight />
                            </Link>
                            :
                            <Link to="/preview" className="link text-primary">
                                <TextTranslate name="word-preview" fallback="Preview"/>
                            </Link>
                        }
                        </>
                    )}
                </div>
            </div>
            <MyDocuments invitation={invitation} isMobile={isMobile} />

            <hr className="d-none d-lg-block" />
        </>
    );
}

const mapStateToProps = (state) => ({
    guests: state.guests?.list || [],
    isMobile: state.general.isMobile
});

export default connect(mapStateToProps)(StatusConfirmed);
